
export default "/assets/user-micro.aa3c814f.svg"